import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { allProducts } from '../../../../services/product';
import { isAuthenticated } from '../../../../services/auth';
import MobileMenuDrawer from '../../drawers';
import SponsoredProducts from '../../../product/SponsoredProducts';
import ProductCard from '../../../product/ProductCard';
import axios from 'axios';
import './HomeContent.css';

const HomeContent = ({ categories }) => {
  const API = (process.env.REACT_APP_API).replace(/\/api$/, '');

  const [products, setProducts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const { user } = isAuthenticated();

  // Normalize text: remove accents and lowercase
  const normalizeText = (text = '') =>
    text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  useEffect(() => {
    loadProducts();
    fetchLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const res = await allProducts();
      setProducts(res.data);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${API}/api/locations`);
      setLocations(res.data);
    } catch (err) {
      setLocations([]);
    }
  };

  const handleAddFavourite = async (productId) => {
    message.success('Adicionado aos Favoritos');
  };

  // eslint-disable-next-line no-extend-native
  Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };

  // Responsividade para tipos de propriedade
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Helper to get location name by id
  const getLocationName = (location) => {
    if (!location) return null;
    if (location.name) return location.name;
    const found = locations.find((l) => l._id === location || l._id === location?._id);
    return found ? found.name : (typeof location === 'string' ? location : '');
  };

  // Adiciona CSS para esconder grid antigo e ajustar espaçamento dos cards no mobile
  // Adicione CSS para o novo card marketplace
  return (
    <div className='container-fluid mb-5 home-container'>
      {user && user.role === 'admin' && (
        <div className={`admin-search-container ${isMobile ? '' : 'admin-search-container-desktop'}`}>            
          <input
            type="text"
            placeholder="Buscar título ou descrição"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className={`admin-search-input ${isMobile ? '' : 'admin-search-input-desktop'}`}
          />
          <button
            onClick={() => { /* optional trigger */ }}
            className="admin-search-button"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>
      )}
      {/* ANÚNCIOS PATROCINADOS */}
      {!searchTerm.trim() ? <SponsoredProducts />
        : <></>}
      {/* FILTRO DE CATEGORIAS (no lugar dos ícones) */}
      <div className="container2 mb-5">
          <h4 className="text-center mb-4 category-title">
            Filtro por Categoria
          </h4>
        <div className="category-overflow">      
          {/* Desktop: grid, Mobile: row scroll */}
          {!isMobile ? (
            <div className="category-grid">
              {categories.map((c, idx) => {
                // Conta apenas produtos ativos para cada categoria
                const activeCount = Array.isArray(products)
                  ? products.filter(
                    (p) => p.category === c._id && p.status === 'active'
                  ).length
                  : 0;
                return (
                  <Link
                    key={c._id}
                    to={`/category/${c._id}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <div className="category-filter">
                      <span className="category-name">{c.name}</span>
                      <span className="category-count">
                        {activeCount} produtos
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="category-scroll">
              {categories.map((c, idx) => (
                <Link
                  key={c._id}
                  to={`/category/${c._id}`}
                  style={{ textDecoration: 'none' }}
                >
                  <div className="category-filter">
                    <span className="category-name-mobile">{c.name}</span>
                    <span className="category-count-mobile">
                      {c.productCount} produtos
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* PRODUTOS EM DESTAQUE */}
      <div className="container-products">
        {/* MOBILE: Drawer de categorias */}
        {isMobile && (
          <div className="mobile-drawer">
            <MobileMenuDrawer categories={categories} />
          </div>
        )}

        {/* Cards */}
        <div className={`home-row ${isMobile ? 'home-row-mobile' : ''}`}>
              {(() => {
                const filteredProducts = products.filter(p => 
                  p.status === 'active' && 
                  (!searchTerm || 
                    normalizeText(p.name).includes(normalizeText(searchTerm)) || 
                    normalizeText(p.description).includes(normalizeText(searchTerm))
                  )
                );
                return loading ? (
                  <div className="text-center py-5 w-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Carregando produtos...</span>
                    </div>
                  </div>
                ) : filteredProducts.length === 0 ? (
                  <div className={isMobile ? "text-center text-muted py-5 w-100" : "text-center text-muted py-5"}>Nenhum produto encontrado.</div>
                ) : (
                  filteredProducts.map((p, i) => (
                    <div key={i} style={{ justifyContent: 'center' }}>
                      <ProductCard
                        product={p}
                        isMobile={isMobile}
                        API={API}
                        showAuthor={true}
                        getLocationName={getLocationName}
                      />
                    </div>
                  ))
                );
              })()}
            </div>
          </div>
    </div>
  );
};

export default HomeContent;